var productsVariants = null
var onSale = false
var soldOut = false
var priceVaries = false
var images = []
var firstVariant = {}
// Override Settings
var bcSfFilterSettings = {
  general: {
    limit: bcSfFilterConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false
  }
}
// Declare Templates
var bcSfFilterTemplate = {
  soldOutClass: ' sold-out',
  comingSoonClass: ' coming-soon',
  lowStockClass: ' low-stock',
  saleClass: ' on-sale',
  soldOutLabelHtml:
    '<span class="soldout bc-sf-filter-label">' +
    bcSfFilterConfig.label_basic.sold_out +
    '</span>',
  saleLabelHtml:
    '<span class="sale bc-sf-filter-label">' +
    bcSfFilterConfig.label_basic.sale +
    '</span>',
  tagLabelHtml:
    '<span class="tag bc-sf-filter-label {{labelTag}}" >{{labelTag}}</span>',
  vendorHtml:
    '<p class="bc-sf-filter-product-item-vendor">{{itemVendorLabel}}</p>',
  // Grid Template
  productGridItemHtml:
    '<div class="product-item js-product-item {{soldOutClass}}{{comingSoonClass}}{{lowStockClass}}">' +
    '<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script><form method="post" action="/cart/add" accept-charset="UTF-8" class="form-product-small js-form-product-small" enctype="multipart/form-data"><input type="hidden" name="form_type" value="product" tabindex="0" class=""><input type="hidden" name="utf8" value="✓" tabindex="0" class="">' +
    '<div class="product-item__select hidden">{{itemSelect}}</div>' +
    '<div class="product-item__inner">' +
    '<div class="low-stock-badge">Low Stock</div>' +
    '<div class="sold-out-badge">Sold Out</div>' +
    '<div class="coming-soon-badge">Coming Soon</div>' +
    '<div class="product-item__image">' +
    '{{variantImagesHtml}}' +
    '</div>' +
    '<div class="product-item__content">{{itemTag}}' +
    '<h5 class="product-item__title">' +
    '<a href="{{itemUrl}}">{{itemTitle}}</a>' +
    '</h5>' +
    '<span class="product-item__price js-product-item-price">{{itemPrice}}</span>' +
    '<span class="sold-out-price">SOLD OUT</span>' +
    '{{variantsHtml}}' +
    '</div>' +
    '</div>' +
    '</form>' +
    '</div>',
  // For List View
  // List Template
  productListItemHtml:
    '<div class="bc-sf-filter-product-item bc-sf-filter-product-item-list {{soldOutClass}}{{saleClass}}{{comingSoonClass}}{{lowStockClass}} {{itemActiveSwapClass}}">' +
    '<div class="bc-sf-filter-product-item-list-col-1">' +
    '<div class="bc-sf-filter-product-item-image">' +
    '<div class="bc-sf-filter-product-item-label">{{itemLabels}}{{itemTagLabels}}</div>' +
    '<a href="{{itemUrl}}" class="bc-sf-filter-product-item-image-link">{{itemImages}}</a>' +
    '</div>' +
    '</div>' +
    '<div class="bc-sf-filter-product-bottom">' +
    '<div class="bc-sf-filter-product-item-list-col-2">' +
    '<a href="{{itemUrl}}" class="bc-sf-filter-product-item-title">{{itemTitle}}</a>' +
    '{{itemVendor}}' +
    '<p class="bc-sf-filter-des">{{itemDescription}}</p>' +
    '</div>' +
    '<div class="bc-sf-filter-product-item-list-col-3">{{itemPrice}}</div>' +
    '</div>' +
    '</div>',
  // End For List View
  // Pagination Template
  previousActiveHtml: '<li><a href="{{itemUrl}}">&lt;&lt; Prev</a></li>',
  previousDisabledHtml: '<li class="disabled"><span>&lt;&lt; Prev</span></li>',
  nextActiveHtml: '<li><a href="{{itemUrl}}">Next &gt;&gt;</a></li>',
  nextDisabledHtml: '<li class="disabled"><span>Next &gt;&gt;</span></li>',
  pageItemHtml: '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  pageItemSelectedHtml: '<li><span class="active">{{itemTitle}}</span></li>',
  pageItemRemainHtml: '<li><span>{{itemTitle}}</span></li>',
  paginateHtml: '<ul>{{previous}}{{pageItems}}{{next}}</ul>',
  // Sorting Template
  sortingHtml:
    '<label><span><span>' +
    bcSfFilterConfig.label.sorting +
    '</span></span></label><ul class="bc-sf-filter-filter-dropdown">{{sortingItems}}</ul>',
  // Show Limit Template
  showLimitHtml:
    '<label>' +
    bcSfFilterConfig.label.show_limit +
    '</label><select class="bc-sf-filter-filter-dropdown">{{showLimitItems}}</select>',
  // Breadcrumb Template
  breadcrumbHtml:
    '<a href="/">' +
    bcSfFilterConfig.label.breadcrumb_home +
    '</a> {{breadcrumbDivider}} {{breadcrumbItems}}',
  breadcrumbDivider: '<span class="divider">/</span>',
  breadcrumbItemLink: '<a href="{{itemLink}}">{{itemTitle}}</a>',
  breadcrumbItemSelected: '<span>{{itemTitle}}</span>'
}

/**
 * Standardizes the escaping of the "$" character
 * since there are conflicts with regex expressions
 * used throughout this file.
 *
 * @param {*} value The value to format
 */
function HH_FormatMoney (value) {
  return bcsffilter.formatMoney(value).replace('$', '&#36;')
}

/** ************************ CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData (data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min // Check a product is on sale
  priceVaries = data.price_min !== data.price_max // Check a product has many prices
  // Convert images to array
  images = data.images_info
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0]
  if (getParam('variant') !== null && getParam('variant') !== '') {
    var paramVariant = data.variants.filter(function (e) {
      return e.id === getParam('variant')
    })
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i]
        break
      }
    }
  }
  return data
}
/** ************************ END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

function addSize (str) {
  return str.insertBeforeLastOccurrence('.jpg', '_662x')
}

String.prototype.insertBeforeLastOccurrence = function (strToFind, strToInsert) {
  var n = this.lastIndexOf(strToFind)
  if (n < 0) return this.toString()
  return this.substring(0, n) + strToInsert + this.substring(n)
}

/** ************************ BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data)
  productsVariants = productsVariants || getVariants()
  // Add Custom class

  /* Half Helix addition: Sold Out Class */
  var soldOutClass = ''
  var totalInventory = 0
  for (
    var i = 0;
    i < data.variants.length;
    i++
  ) {
    var currentVariant = data.variants[i]
    var realVariant = productsVariants[currentVariant.id]
    var realInventory = realVariant ? realVariant.inventory_quantity : currentVariant.inventory_quantity

    totalInventory += realInventory
  }

  if (totalInventory === 0) {
    soldOutClass = bcSfFilterTemplate.soldOutClass
  }

  var comingSoonClass = ''
  console.log(data.tags)
  if (data.tags.indexOf('coming_soon') > -1) {
    console.log('coming soon!')
    comingSoonClass = bcSfFilterTemplate.comingSoonClass
  }
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : ''
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass)
  itemHtml = itemHtml.replace(/{{comingSoonClass}}/g, comingSoonClass)
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass)
  // Add Grid Width class
  itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data))
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data))
  // Add TAG Label
  itemHtml = itemHtml.replace(
    /{{itemTagLabels}}/g,
    buildTagLabels(data, false)
  )
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data))
  // Add Price
  // Not regex to prevent "$<..>" being interpreted as a regex match placeholder
  itemHtml = itemHtml.replace('{{itemPrice}}', buildPrice(data))
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data))
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap
    ? 'has-bc-swap-image'
    : ''
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass)

  // Add data json
  var self = this
  var itemJson = {
    id: data.id,
    title: data.title,
    handle: data.handle,
    vendor: data.vendor,
    variants: data.variants,
    url: self.buildProductItemUrl(data),
    options_with_values: data.options_with_values,
    images: data.images,
    available: data.available,
    price_min: data.price_min,
    price_max: data.price_max,
    compare_at_price_min: data.compare_at_price_min,
    compare_at_price_max: data.compare_at_price_max
  }
  itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson))

  // Tag/Badge
  var tagHtml = ''
  var tagSubtitle = Shopify.subtitle

  for (var i = 0; i < data.tags.length; i++) {
    var _tag = data.tags[i]

    if (_tag.indexOf(tagSubtitle) !== -1) {
      var _tagText = _tag.replace(tagSubtitle, '').trim()

      tagHtml = '<span class="product-item__subtitle">' + _tagText + '</span>'

      break
    }
  }

  itemHtml = itemHtml.replace(/{{itemTag}}/g, tagHtml)

  // Product Item Select
  var selectHtml = ''
  var option = ''
  var selectVariants = data.variants
  var priceHtml = ''

  for (
    var selectVariant = 0;
    selectVariant < selectVariants.length;
    selectVariant++
  ) {
    var disabledOption = ''
    var selectedOption = ''
    var selectVariantCurrent = selectVariants[selectVariant]
    var selectVariantCompared = selectVariantCurrent.compare_at_price
    var selectVariantPrice = selectVariantCurrent.price
    var priceHtml = ''

    if (selectVariantCompared > selectVariantPrice) {
      priceHtml =
        '<del class="price__amount"><span class="money">' +
        HH_FormatMoney(selectVariantCompared) +
        '</span></del><ins class="price__amount"><span class="money">' +
        HH_FormatMoney(selectVariantPrice) +
        '</span></ins>'
    } else {
      priceHtml =
        '<span class="price__amount"><span class="money">' +
        HH_FormatMoney(selectVariantPrice) +
        '</span></span>'
    }

    priceHtml = priceHtml.replace('$', '&#36;').replace(/"/g, "'")

    if (!selectVariantCurrent.available) {
      disabledOption = 'disabled'
    }

    if (selectVariant === 0) {
      selectedOption = 'selected'
    }

    var option2 = ''
    if (typeof selectVariantCurrent.options[1] !== 'undefined') {
      option2 = selectVariantCurrent.options[1]
    }
    var option3 = ''
    if (typeof selectVariantCurrent.options[2] !== 'undefined') {
      option3 = selectVariantCurrent.options[2]
    }

    option =
      option +
      '<option value="' +
      selectVariantCurrent.id +
      '" data-price="' +
      priceHtml +
      '" data-option-1="' +
      selectVariantCurrent.options[0] +
      '" data-option-2="' +
      option2 +
      '" data-option-3="' +
      option3 +
      '" data-inventory="' +
      selectVariantCurrent.inventory_quantity +
      '"' +
      disabledOption +
      ' ' +
      selectedOption +
      '>' +
      selectVariantCurrent.title +
      '</option>'
  }

  selectHtml =
    '<select name="id" class="product-single__variants js-product-item-select">' +
    option +
    '</select>'

  itemHtml = itemHtml.replace(/{{itemSelect}}/g, selectHtml)

  /* Half Helix addition: Low Stock Class */
  var lowStockClass = ''
  if ((selectVariants.length > 0) && (soldOutClass == '')) {
    var totalInventory = 0

    for (
      var selectVariant = 0;
      selectVariant < selectVariants.length;
      selectVariant++
    ) {
      var selectVariantCurrent = selectVariants[selectVariant]
      var realVariant = productsVariants[selectVariantCurrent.id]
      var realInventory = realVariant ? realVariant.inventory_quantity : selectVariantCurrent.inventory_quantity

      totalInventory += realInventory
    }

    /* Crosby South 23 Sep 2026: size-aware low stock rule.
       Multi-size products: badge when more than half the sizes are out, or fewer than 4 units remain in total.
       Single-variant products: badge when fewer than 3 units remain.
       Previous rule was totalInventory > 0 && totalInventory < 10. */
    var sizesOut = 0
    var sizeCount = selectVariants.length
    for (
      var lsIdx = 0;
      lsIdx < selectVariants.length;
      lsIdx++
    ) {
      var lsVariant = productsVariants[selectVariants[lsIdx].id]
      var lsInventory = lsVariant ? lsVariant.inventory_quantity : selectVariants[lsIdx].inventory_quantity
      if (!(lsInventory > 0)) {
        sizesOut++
      }
    }
    if (totalInventory > 0) {
      if (sizeCount > 1) {
        if ((sizesOut / sizeCount > 0.5) || (totalInventory < 4)) {
          lowStockClass = bcSfFilterTemplate.lowStockClass
        }
      } else if (totalInventory < 3) {
        lowStockClass = bcSfFilterTemplate.lowStockClass
      }
    }
  }
  itemHtml = itemHtml.replace(/{{lowStockClass}}/g, lowStockClass)

  // Color Swatches
  var variantsHtml = ''
  var optionValues = data.options_with_values
  var currentUrl = window.location.search
    .replace('%20', '-')
    .replace('%2F', '/')
  var options = ''
  var radioOptionHtml = ''
  var idxColor = ''
  var colorsArr = []
  var colorsNewArr = []
  var variantImagesHtml = ''

  if (currentUrl.indexOf('pf_opt_color=') !== -1) {
    const colorArr = currentUrl.split('pf_opt_color=')
    colorArr.shift()

    for (var i = 0; i < colorArr.length; i++) {
      var colorArrItem = colorArr[i]
      var colorOnly = colorArrItem

      if (colorArrItem.indexOf('&pf') !== -1) {
        colorOnly = colorArrItem.split('&pf')[0]
      }

      colorsArr.push(colorOnly)
    }
  }

  for (var i = 0; i < optionValues.length; i++) {
    var optionHandle = handleize(optionValues[i].name).replace('colour', 'color');

    if (optionHandle === Shopify.colorHandle) {
      options = optionValues[i].values
      idxColor = i
    }
  }

  if (options != '') {
    var optionIdx = idxColor + 1
    var filteredFlag = true

    for (var i = 0; i < options.length; i++) {
      var variantTitle = options[i].title
      var variantTitleHandle = handleize(variantTitle)
      var checkedHtml = ''
      var filteredClass = ''

      if (i === 0) {
        checkedHtml = 'checked'
      }

      if (colorsArr != '' && filteredFlag) {
        for (var x = 0; x < colorsArr.length; x++) {
          var colorValue = colorsArr[x]
          var colorValueHandle = handleize(colorValue)

          if (colorValueHandle === variantTitleHandle) {
            filteredClass = ' class="js-radio-filtered"'
            filteredFlag = false
          }
        }
      }

      radioOptionHtml =
        radioOptionHtml +
        '<li><div class="radio-color js-radio-color-item"><input type="radio" name="radios-collection-' +
        index +
        '" id="radios-collection-' +
        variantTitleHandle +
        '-' +
        index +
        '-' +
        i +
        '" value="' +
        variantTitleHandle +
        '" data-option="' +
        optionIdx +
        '" data-value="' +
        variantTitle +
        '" data-index="' +
        i +
        '" ' +
        checkedHtml +
        ' data-image-target="' +
        data.handle +
        '-' +
        index +
        '"' +
        filteredClass +
        '><label for="radios-collection-' +
        variantTitleHandle +
        '-' +
        index +
        '-' +
        i +
        '"' +
        ' class="color-' +
        variantTitleHandle +
        '"></label></div></li>'
    }

    for (var i = 0; i < data.variants.length; i++) {
      var optionColor = data.variants[i].options[idxColor]
      var classExpanded = ''
      var variantImageHtml = ''
      var emptyVariantImage = ''
      var variantImageHoverHtml = ''

      if (colorsNewArr.indexOf(optionColor) <= -1) {
        colorsNewArr.push(optionColor)

        if (i === 0) {
          classExpanded = 'expanded'
        }

        if (data.variants[i].image != null) {
          variantImageHtml = '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload" data-src="' + addSize(data.variants[i].image) + '">'
        } else if (data.images.length > 0) {
          variantImageHtml = '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload" data-src="' + addSize(data.featured_image.src) + '">'
        } else {
          emptyVariantImage = ' no-image'
        }

        if (data.images[1] != null){
          if (data.tags.indexOf('disable-hover') > -1) {
            variantImageHoverHtml = ''
          } else {
            variantImageHoverHtml = '<img src="' + data.images[1].src + '" class="lazyload hover" >'
          }
        }

        variantImagesHtml =
          variantImagesHtml +
          '<figure class="' +
          classExpanded +
          emptyVariantImage +
          '" data-variant-image="' +
          data.handle +
          '-' +
          index +
          '"><a href="' +
          self.buildProductItemUrl(data) +
          '?variant=' +
          data.variants[i].id +
          '"></a>' +
          variantImageHtml +
          variantImageHoverHtml
          '</figure>'
      }
    }
  } else {
    if (data.images.length > 1) {
      variantImagesHtml =
        '<figure class="hover-alt"><a href="' +
        self.buildProductItemUrl(data) +
        '"></a><img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload" data-src="' +
        addSize(data.featured_image.src) +
        '"></figure><figure class="hover-alt"><a href="' +
        self.buildProductItemUrl(data) +
        '"></a><img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload" data-src="' +
        addSize(data.images[1].src) +
        '"></figure>'
    } else if (data.images.length === 1) {
      variantImagesHtml =
        '<figure class="expanded"><a href="' +
        self.buildProductItemUrl(data) +
        '"></a><img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload" data-src="' +
        addSize(data.featured_image.src) +
        '"></figure>'
    } else {
      variantImagesHtml =
        '<figure class="no-image"><a href="' +
        self.buildProductItemUrl(data) +
        '"></a></figure>'
    }
  }

  if (radioOptionHtml != '') {
    variantsHtml =
      '<div class="product-item__variants"><ul class="list-radios-colors js-radios-colors">' +
      radioOptionHtml +
      '</ul></div>'
  }

  itemHtml = itemHtml.replace(/{{variantsHtml}}/g, variantsHtml)
  itemHtml = itemHtml.replace(/{{variantImagesHtml}}/g, variantImagesHtml)

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id)
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title)
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle)
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor)
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data))
  return itemHtml
}
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data) {
  // For List View
  /** * Prepare data ***/
  var images = data.images_info
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min // Check a product is on sale
  var priceVaries = data.price_min != data.price_max // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0]
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function (e) {
      return e.id === getParam('variant')
    })
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i]
        break
      }
    }
  }
  /** * End Prepare data ***/
  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data)
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : ''
  var comingSoonClass = soldOut ? bcSfFilterTemplate.comingSoonClass : ''
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : ''
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass)
  itemHtml = itemHtml.replace(/{{comingSoonClass}}/g, comingSoonClass)
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass)
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data))
  // Add TAG Label
  itemHtml = itemHtml.replace(
    /{{itemTagLabels}}/g,
    buildTagLabels(data, false)
  )
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data))
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data))
  // Add Price
  // Not regex to prevent "$<..>" being interpreted as a regex match placeholder
  var itemPriceHtml = buildPrice(data, onSale, priceVaries)
  itemHtml = itemHtml.replace('{{itemPrice}}', itemPriceHtml)
  // Description
  var itemDescription = jQ('<p>' + data.body_html + '</p>').text()
  itemDescription =
    itemDescription.split(' ').length > 40
      ? itemDescription
        .split(' ')
        .splice(0, 40)
        .join(' ') + '...'
      : itemDescription
        .split(' ')
        .splice(0, 40)
        .join(' ')
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription)
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap
    ? 'has-bc-swap-image'
    : ''
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass)
  // Add main attribute
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title)
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor)
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data))
  return itemHtml
  // End For List View
}
/** ************************ END BUILD PRODUCT LIST **************************/
/** ************************ BUILD PRODUCT ITEM ELEMENTS **************************/

function handleize (str) {
  return str
    .toLowerCase()
    .replace(/[^\wÀ-ɏ]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace('_', '-')
}

function buildGridWidthClass () {
  var gridWidthClass = ''
  // On PC
  switch (bcSfFilterConfig.custom.products_per_row) {
    case 2:
      gridWidthClass = 'bc-sf-filter-grid-width-2'
      break
    case 3:
      gridWidthClass = 'bc-sf-filter-grid-width-3'
      break
    case 5:
      gridWidthClass = 'bc-sf-filter-grid-width-5'
      break
    default:
      gridWidthClass = 'bc-sf-filter-grid-width-4'
      break
  }
  // On Mobile
  switch (bcSfFilterConfig.custom.products_per_row_mobile) {
    case 1:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-1'
      break
    case 3:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-3'
      break
    default:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-2'
      break
  }
  return gridWidthClass
}

function buildImages (data) {
  var html = ''
  // Build Main Image
  var thumbUrl =
    images.length > 0
      ? bcsffilter.optimizeImage(images[0]['src'])
      : bcSfFilterConfig.general.no_image_url
  var secondImage = ''

  if (images.length > 1) {
    secondImage =
      '<figure><img src="' +
      bcsffilter.optimizeImage(images[1]['src']) +
      '" /></figure>'
  }

  html += '<figure><img src="' + thumbUrl + '" /></figure>' + secondImage
  // Build Image Swap
  if (bcSfFilterConfig.custom.active_image_swap) {
    var flipImageUrl =
      images.length > 1 ? bcsffilter.optimizeImage(images[1]['src']) : thumbUrl
    html +=
      '<img src="' +
      flipImageUrl +
      '" class="bc-sf-filter-product-item-flip-image" />'
  }
  return html
}

function buildVendor (data) {
  var html = ''
  if (bcSfFilterConfig.custom.show_vendor) {
    html = bcSfFilterTemplate.vendorHtml
  }
  return html
}

function buildPrice (data) {
  var html = ''
  if (bcSfFilterConfig.custom.show_price) {
    html = ''
    if (onSale) {
      html +=
        '<del class="price__amount"><span class="money">' +
        HH_FormatMoney(data.compare_at_price_min) +
        '</span></del> '
      html +=
        '<ins class="price__amount"><span class="money">' +
        HH_FormatMoney(data.price_min) +
        '</span></ins>'
    } else {
      if (priceVaries) {
        html += bcSfFilterConfig.label_basic.from + ' '
      }
      html +=
        '<span class="price__amount"><span class="money">' +
        HH_FormatMoney(data.price_min) +
        '</span></span>'
    }
    html += ''
  }
  return html
}

function buildLabels (data) {
  // Build Sold out label
  var soldOutLabel = ''
  if (bcSfFilterConfig.custom.show_sold_out_label && soldOut) {
    soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml.replace(
      /{{style}}/g,
      ''
    )
  }
  // Build Sale label
  var saleLabel = ''
  if (bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut) {
    saleLabel = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, '')
  }
  // Build Labels
  return soldOutLabel + saleLabel
}
// BUILD LABEL PRODUCT WITH TAGS
function buildTagLabels (data, showall) {
  if (showall) {
    var tagLabel = ''
    if (data.tags) {
      for (var i = 0; i < data.tags.length; i++) {
        var tag = data.tags[i]
        if (tag.indexOf('pfs:label') !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(
            /{{labelTag}}/g,
            tag.split('pfs:label-')[1]
          )
          tagLabel += preTagLabel
        }
      }
    }
  } else {
    var tagLabel = ''
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        var tag = data.tags[i]
        if (tag.indexOf('pfs:label') !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(
            /{{labelTag}}/g,
            tag.split('pfs:label-')[1]
          )
          tagLabel += preTagLabel
          break
        }
      }
    }
  }
  return tagLabel
}
/** ************************ END BUILD PRODUCT ITEM ELEMENTS **************************/
/** ************************ BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page)
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit)
  // If it has only one page, clear Pagination
  if (totalPage === 1) {
    jQ(this.selector.pagination).html('')
    return false
  }
  if (this.getSettingValue('general.paginationType') === 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml
    // Build Previous
    var previousHtml =
      currentPage > 1
        ? bcSfFilterTemplate.previousActiveHtml
        : bcSfFilterTemplate.previousDisabledHtml
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      this.buildToolbarLink('page', currentPage, currentPage - 1)
    )
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml)
    // Build Next
    var nextHtml =
      currentPage < totalPage
        ? bcSfFilterTemplate.nextActiveHtml
        : bcSfFilterTemplate.nextDisabledHtml
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      this.buildToolbarLink('page', currentPage, currentPage + 1)
    )
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml)
    // Create page items array
    var beforeCurrentPageArr = []
    for (
      var iBefore = currentPage - 1;
      iBefore > currentPage - 3 && iBefore > 0;
      iBefore--
    ) {
      beforeCurrentPageArr.unshift(iBefore)
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...')
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1)
    }
    beforeCurrentPageArr.push(currentPage)
    var afterCurrentPageArr = []
    for (
      var iAfter = currentPage + 1;
      iAfter < currentPage + 3 && iAfter <= totalPage;
      iAfter++
    ) {
      afterCurrentPageArr.push(iAfter)
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...')
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage)
    }
    // Build page items
    var pageItemsHtml = ''
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr)
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] === '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml
      } else {
        pageItemsHtml +=
          pageArr[iPage] === currentPage
            ? bcSfFilterTemplate.pageItemSelectedHtml
            : bcSfFilterTemplate.pageItemHtml
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage])
      pageItemsHtml = pageItemsHtml.replace(
        /{{itemUrl}}/g,
        this.buildToolbarLink('page', currentPage, pageArr[iPage])
      )
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml)
    jQ(this.selector.pagination).html(paginationHtml)
  }
}
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
  if (
    bcSfFilterConfig.custom.show_sorting &&
    bcSfFilterTemplate.hasOwnProperty('sortingHtml')
  ) {
    jQ(this.selector.topSorting).html('')
    var sortingArr = this.getSortingList()
    if (sortingArr) {
      var paramSort = this.queryParams.sort || ''
      // Build content
      var sortingItemsHtml = ''
      for (var k in sortingArr) {
        activeClass = ''
        if (paramSort === k) {
          activeClass = 'active'
        }
        sortingItemsHtml +=
          '<li><a href="#" data-sort="' +
          k +
          '" class="' +
          activeClass +
          '">' +
          sortingArr[k] +
          '</a></li>'
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(
        /{{sortingItems}}/g,
        sortingItemsHtml
      )
      jQ('.bc-sf-filter-custom-sorting').html(html)
      if (
        jQ('.bc-sf-filter-custom-sorting').hasClass('bc-sf-filter-sort-active')
      ) {
        jQ('.bc-sf-filter-custom-sorting').toggleClass(
          'bc-sf-filter-sort-active'
        )
      }

      var labelSort = ''
      if (paramSort.length > 0) {
        var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_')
        labelSort = bcSfFilterConfig.label[labelHandle]
      } else {
        labelSort = bcSfFilterConfig.label.sorting
      }

      jQ('.bc-sf-filter-custom-sorting label span span').text(labelSort)
    }
  }
}

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function () {
  var _this = this
  jQ('.bc-sf-filter-filter-dropdown a').click(function (e) {
    e.preventDefault()
    onInteractWithToolbar(
      e,
      'sort',
      _this.queryParams.sort,
      jQ(this).data('sort')
    )
  })

  jQ('.bc-sf-filter-custom-sorting > label').click(function () {
    if (!jQ('.bc-sf-filter-filter-dropdown').is(':animated')) {
      jQ('.bc-sf-filter-filter-dropdown')
        .toggle()
        .parent()
        .toggleClass('bc-sf-filter-sort-active')
      jQ('#bc-sf-filter-tree').hide()
    }
  })

  jQ(this.getSelector('filterTreeMobileButton')).click(function () {
    jQ('#bc-sf-filter-top-sorting-mobile .bc-sf-filter-filter-dropdown').hide()
  })
}
// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function () {
  var itemHtml = '<span>' + bcSfFilterConfig.label.toolbar_viewas + '</span>'
  itemHtml +=
    '<a href="' +
    this.buildToolbarLink('display', 'list', 'grid') +
    '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>'
  itemHtml +=
    '<a href="' +
    this.buildToolbarLink('display', 'grid', 'list') +
    '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>'
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'))
  var listProductSelector = jQ(this.getSelector('products'))
  topDisplayTypeSelector.html(itemHtml)
  // Active current display type
  topDisplayTypeSelector
    .find('.bc-sf-filter-display-item')
    .removeClass('active')
  if (this.queryParams.display === 'list') {
    topDisplayTypeSelector
      .find('.bc-sf-filter-display-list')
      .addClass('active')
    listProductSelector
      .removeClass('bc-sf-filter-grid-view-items')
      .addClass('bc-sf-filter-list-view-items')
  } else if (this.queryParams.display === 'grid') {
    topDisplayTypeSelector
      .find('.bc-sf-filter-display-grid')
      .addClass('active')
    listProductSelector
      .removeClass('bc-sf-filter-list-view-items')
      .addClass('bc-sf-filter-grid-view-items')
  }
}
// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function () {
  var _this = this
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'))
  var listProductSelector = jQ(this.getSelector('products'))
  jQ(this.getSelector('topDisplayType') + ' a').click(function (e) {
    e.preventDefault()
    _this.internalClick = true
    jQ(this)
      .parent()
      .children()
      .removeClass('active')
    jQ(this).addClass('active')
    if (_this.queryParams.display === 'list') {
      topDisplayTypeSelector
        .find('.bc-sf-filter-display-list')
        .addClass('active')
      listProductSelector
        .removeClass('bc-sf-filter-grid-view-items')
        .addClass('bc-sf-filter-list-view-items')
    } else if (_this.queryParams.display === 'grid') {
      topDisplayTypeSelector
        .find('.bc-sf-filter-display-grid')
        .addClass('active')
      listProductSelector
        .removeClass('bc-sf-filter-list-view-items')
        .addClass('bc-sf-filter-grid-view-items')
    }
    var newUrl = jQ(this).attr('href')
    _this.onChangeData(newUrl, 'display')
  })
}
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function () {
  if (
    bcSfFilterConfig.custom.show_limit &&
    bcSfFilterTemplate.hasOwnProperty('showLimitHtml')
  ) {
    jQ(this.selector.topShowLimit).html('')
    var numberList = this.getSettingValue('general.showLimitList')
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = ''
      var arr = numberList.split(',')
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml +=
          '<option value="' +
          arr[k].trim() +
          '">' +
          arr[k].trim() +
          '</option>'
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(
        /{{showLimitItems}}/g,
        showLimitItemsHtml
      )
      jQ(this.selector.topShowLimit).html(html)
      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit)
    }
  }
}
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function (colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
    var breadcrumbItemsHtml = ''
    if (
      typeof colData !== 'undefined' &&
      colData.hasOwnProperty('collection')
    ) {
      var colInfo = colData.collection
      if (
        typeof this.collectionTags !== 'undefined' &&
        this.collectionTags !== null
      ) {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink
          .replace(/{{itemLink}}/g, '/collections/' + colInfo.handle)
          .replace(/{{itemTitle}}/g, colInfo.title)
        breadcrumbItemsHtml += ' {{breadcrumbDivider}} '
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(
          /{{itemTitle}}/g,
          this.collectionTags[0]
        )
      } else {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(
          /{{itemTitle}}/g,
          colInfo.title
        )
      }
    } else {
      breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(
        /{{itemTitle}}/g,
        this.getSettingValue('label.defaultCollectionHeader')
      )
    }
    var html = bcSfFilterTemplate.breadcrumbHtml.replace(
      /{{breadcrumbItems}}/g,
      breadcrumbItemsHtml
    )
    html = html.replace(
      /{{breadcrumbDivider}}/g,
      bcSfFilterTemplate.breadcrumbDivider
    )
    jQ(this.selector.breadcrumb).html(html)
  }
}
/** ************************ END BUILD TOOLBAR **************************/
function matchHeightImage () {
  jQ('.bc-sf-filter-product-item-main-image')
    .load(function () {
      var imageContainer = jQ(this).parent()
      imageContainer.css('width', '100%').css('height', jQ(this).height())
    })
    .each(function () {
      if (this.complete) jQ(this).load()
    })
}
// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
  /* start-initialize-bc-al */
  var self = this
  var alEnable = true
  if (
    self.getSettingValue('actionlist.qvEnable') != '' ||
    self.getSettingValue('actionlist.atcEnable') != ''
  ) {
    alEnable =
      self.getSettingValue('actionlist.qvEnable') ||
      self.getSettingValue('actionlist.atcEnable')
  }
  if (alEnable === true && typeof BCActionList !== 'undefined') {
    if (typeof bcActionList === 'undefined') {
      bcActionList = new BCActionList()
    } else {
      if (
        typeof bcAlParams !== 'undefined' &&
        typeof bcSfFilterParams !== 'undefined'
      ) {
        bcActionList.initFlag = false
        bcActionList.alInit(bcSfFilterParams, bcAlParams)
      } else {
        bcActionList.alInit()
      }
    }
  }
  /* end-initialize-bc-al */
  // Call theme init function
  if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
    $(theme.init)
  }
  // End For List View
}
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
  var _this = this
  var totalProduct =
    data.total_product +
    '<span> ' +
    bcSfFilterConfig.label.items_with_count_other +
    '</span>'
  if (data.total_product === 1) {
    totalProduct =
      data.total_product +
      '<span> ' +
      bcSfFilterConfig.label.items_with_count_one +
      '</span>'
  }
  jQ('#bc-sf-filter-total-product').html(totalProduct)
  matchHeightImage()
  jQ(window).resize(function () {
    matchHeightImage()
  })

  jQ('body')
    .find('.bc-sf-filter-skeleton-button')
    .remove()

  // Prevent double tap on iOS
  this.isMobile() &&
    jQ('.bc-sf-filter-product-item')
      .find('a')
      .on('touchstart', function () {
        isScrolling = !1
      })
      .on('touchmove', function () {
        isScrolling = !0
      })
      .on('touchend', function () {
        isScrolling || (window.location = jQ(this).attr('href'))
      });

  // Fix image not loaded on mobile
  (this.isMobile() || navigator.userAgent.match(/iPad/i) != null) &&
    (setTimeout(function () {
      jQ('.bc-sf-filter-product-item-image img').each(function () {
        var a = jQ(this).attr('src') + '3'
        jQ(this).attr('src', a)
      })
    }, 200),
    setTimeout(function () {
      jQ('.bc-sf-filter-product-item-image img').each(function () {
        var a = jQ(this).attr('src') + '3'
        jQ(this).attr('src', a)
      })
    }, 2e3))

  /* Counter Items */
  var $selectedItem = jQ('.bc-sf-filter-selected-items .selected-item')
  var $list = jQ('.js-selected-items')
  var newSelectedItems = ''
  var $header = jQ('.header')
  var headerBarHeight = $header.find('.header__bar').outerHeight() || 0
  var $main = jQ('.main')
  var $headerBreadcrumbs = jQ('.header .header__breadcrumbs')
  var $megaMenu = jQ('.nav .mega-menu')
  var $clearBtn = jQ('.bc-sf-filter-clear-all')
  var clearBtnFlag = false
  var $newClearBtn = jQ('.js-btn-filter-clear')
  var $btnFilter = jQ('.js-btn-filter span')
  var filterNumber = 0

  if ($selectedItem.length) {
    filterNumber = $selectedItem.length

    $selectedItem.each(function () {
      var $this = jQ(this)
      var selectedVal = $this.find('.selected-type strong').text()
      var $swatchOptions = jQ('.bc-sf-filter-option-swatch')
      var swatchStylesHtml = ''

      if (
        $swatchOptions.length &&
        $swatchOptions.find(
          '[data-title="' + selectedVal + '"] .bc-sf-filter-option-swatch-image'
        ).length
      ) {
        var swatchStyles = $swatchOptions
          .find(
            '[data-title="' +
              selectedVal +
              '"] .bc-sf-filter-option-swatch-image'
          )
          .attr('style')

        swatchStylesHtml =
          '<small class="color-' + handleize(selectedVal) + '"></small>'
      }

      newSelectedItems +=
        '<li><strong>' +
        selectedVal +
        '</strong>' +
        swatchStylesHtml +
        '<span class="btn-close btn-close--reset"></span></li>'
    })
  }

  if ($list.length) {
    $list.html(newSelectedItems)
  }

  if ($btnFilter.length) {
    $btnFilter.text('(' + filterNumber + ')')

    if (filterNumber > 0) {
      $btnFilter.removeClass('hidden')
    } else {
      $btnFilter.addClass('hidden')
    }
  }

  if ($clearBtn.length) {
    clearBtnFlag = true
  }

  if ($newClearBtn.length) {
    if (clearBtnFlag) {
      $newClearBtn.removeClass('hidden').text($clearBtn.text())
    } else {
      $newClearBtn.addClass('hidden')
    }
  }

  if (!$header.data('index')) {
    $main.css(
      'padding-top',
      $header.find('.header__content').outerHeight() + headerBarHeight
    )
  }

  // Click Products
  var $checkedInput = jQ('.js-radio-color-item input:checked')
  var $filteredInput = jQ('.js-radio-color-item input.js-radio-filtered')
  if ($checkedInput.length) {
    $checkedInput.attr('checked', false).attr('checked', true).trigger('click')
  }

  if ($filteredInput.length) {
    $filteredInput.trigger('click')
  }

  // Result Items
  var $resultsElement = jQ('.js-search-count-results')
  if ($resultsElement.length) {
    $resultsElement.find('small').text(data.total_product)
  }

  // Lazy Load
  var myLazyLoad = new LazyLoad({
    elements_selector: '.lazyload'
  })
}

// Build Default layout
function buildDefaultLink (a, b) {
  var c = window.location.href.split('?')[0]
  return (c += '?' + a + '=' + b)
}
BCSfFilter.prototype.buildDefaultElements = function (a) {
  if (
    bcSfFilterConfig.general.hasOwnProperty('collection_count') &&
    jQ('#bc-sf-filter-bottom-pagination').length > 0
  ) {
    var b = bcSfFilterConfig.general.collection_count
    var c = parseInt(this.queryParams.page)
    var d = Math.ceil(b / this.queryParams.limit)
    if (d === 1) return jQ(this.selector.pagination).html(''), !1
    if (this.getSettingValue('general.paginationType') === 'default') {
      var e = bcSfFilterTemplate.paginateHtml
      var f = '';
      (f =
        c > 1
          ? bcSfFilterTemplate.hasOwnProperty('previousActiveHtml')
            ? bcSfFilterTemplate.previousActiveHtml
            : bcSfFilterTemplate.previousHtml
          : bcSfFilterTemplate.hasOwnProperty('previousDisabledHtml')
            ? bcSfFilterTemplate.previousDisabledHtml
            : ''),
      (f = f.replace(/{{itemUrl}}/g, buildDefaultLink('page', c - 1))),
      (e = e.replace(/{{previous}}/g, f))
      var g = '';
      (g =
        c < d
          ? bcSfFilterTemplate.hasOwnProperty('nextActiveHtml')
            ? bcSfFilterTemplate.nextActiveHtml
            : bcSfFilterTemplate.nextHtml
          : bcSfFilterTemplate.hasOwnProperty('nextDisabledHtml')
            ? bcSfFilterTemplate.nextDisabledHtml
            : ''),
      (g = g.replace(/{{itemUrl}}/g, buildDefaultLink('page', c + 1))),
      (e = e.replace(/{{next}}/g, g))
      for (var h = [], i = c - 1; i > c - 3 && i > 0; i--) h.unshift(i)
      c - 4 > 0 && h.unshift('...'), c - 4 >= 0 && h.unshift(1), h.push(c)
      for (var j = [], k = c + 1; k < c + 3 && k <= d; k++) j.push(k)
      c + 3 < d && j.push('...'), c + 3 <= d && j.push(d)
      for (var l = '', m = h.concat(j), n = 0; n < m.length; n++) {
        m[n] === '...'
          ? (l += bcSfFilterTemplate.pageItemRemainHtml)
          : (l +=
              m[n] === c
                ? bcSfFilterTemplate.pageItemSelectedHtml
                : bcSfFilterTemplate.pageItemHtml),
        (l = l.replace(/{{itemTitle}}/g, m[n])),
        (l = l.replace(/{{itemUrl}}/g, buildDefaultLink('page', m[n])))
      }
      (e = e.replace(/{{pageItems}}/g, l)),
      jQ(this.selector.pagination).html(e)
    }
  }
  if (
    bcSfFilterTemplate.hasOwnProperty('sortingHtml') &&
    jQ(this.selector.topSorting).length > 0
  ) {
    jQ(this.selector.topSorting).html('')
    var o = this.getSortingList()
    if (o) {
      var p = ''
      for (var q in o) p += '<option value="' + q + '">' + o[q] + '</option>'
      var r = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, p)
      jQ(this.selector.topSorting).html(r)
      var s =
        void 0 !== this.queryParams.sort_by
          ? this.queryParams.sort_by
          : this.defaultSorting
      jQ(this.selector.topSorting + ' select').val(s),
      jQ(this.selector.topSorting + ' select').change(function (a) {
        window.location.href = buildDefaultLink('sort_by', jQ(this).val())
      })
    }
  }
}

BCSfFilter.prototype.prepareProductData = function (data) {
  var countData = data.length
  for (var k = 0; k < countData; k++) {
    data[k]['images'] = data[k]['images_info']
    if (data[k]['images'].length > 0) {
      data[k]['featured_image'] = data[k]['images'][0]
    } else {
      data[k]['featured_image'] = {
        src: bcSfFilterConfig.general.no_image_url,
        width: '',
        height: '',
        aspect_ratio: 0
      }
    }
    data[k]['url'] = '/products/' + data[k].handle
    var optionsArr = []
    var countOptionsWithValues = data[k]['options_with_values'].length
    for (var i = 0; i < countOptionsWithValues; i++) {
      optionsArr.push(data[k]['options_with_values'][i]['name'])
    }
    data[k]['options'] = optionsArr
    if (
      typeof bcSfFilterConfig.general.currencies !== 'undefined' &&
      bcSfFilterConfig.general.currencies.length > 1
    ) {
      var currentCurrency = bcSfFilterConfig.general.current_currency
        .toLowerCase()
        .trim()
      function updateMultiCurrencyPrice (oldPrice, newPrice) {
        if (typeof newPrice !== 'undefined') {
          return newPrice
        }
        return oldPrice
      }
      data[k].price_min = updateMultiCurrencyPrice(
        data[k].price_min,
        data[k]['price_min_' + currentCurrency]
      )
      data[k].price_max = updateMultiCurrencyPrice(
        data[k].price_max,
        data[k]['price_max_' + currentCurrency]
      )
      data[k].compare_at_price_min = updateMultiCurrencyPrice(
        data[k].compare_at_price_min,
        data[k]['compare_at_price_min_' + currentCurrency]
      )
      data[k].compare_at_price_max = updateMultiCurrencyPrice(
        data[k].compare_at_price_max,
        data[k]['compare_at_price_max_' + currentCurrency]
      )
    }
    (data[k]['price_min'] *= 100),
    (data[k]['price_max'] *= 100),
    (data[k]['compare_at_price_min'] *= 100),
    (data[k]['compare_at_price_max'] *= 100)
    data[k]['price'] = data[k]['price_min']
    data[k]['compare_at_price'] = data[k]['compare_at_price_min']
    data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']
    var firstVariant = data[k]['variants'][0]
    if (getParam('variant') !== null && getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id === getParam('variant')
      })
      if (typeof paramVariant[0] !== 'undefined') { firstVariant = paramVariant[0] }
    } else {
      var countVariants = data[k]['variants'].length
      for (var i = 0; i < countVariants; i++) {
        if (data[k]['variants'][i].available) {
          firstVariant = data[k]['variants'][i]
          break
        }
      }
    }
    data[k]['selected_or_first_available_variant'] = firstVariant
    var countVariants = data[k]['variants'].length
    for (var i = 0; i < countVariants; i++) {
      var variantOptionArr = []
      var count = 1
      var variant = data[k]['variants'][i]
      var variantOptions = variant['merged_options']
      if (Array.isArray(variantOptions)) {
        var countVariantOptions = variantOptions.length
        for (var j = 0; j < countVariantOptions; j++) {
          var temp = variantOptions[j].split(':')
          data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]
          data[k]['variants'][i]['option_' + temp[0]] = temp[1]
          variantOptionArr.push(temp[1])
        }
        data[k]['variants'][i]['options'] = variantOptionArr
      }
      data[k]['variants'][i]['compare_at_price'] =
        parseFloat(data[k]['variants'][i]['compare_at_price']) * 100
      data[k]['variants'][i]['price'] =
        parseFloat(data[k]['variants'][i]['price']) * 100
    }
    data[k]['description'] = data[k]['content'] = data[k]['body_html']
    if (
      data[k].hasOwnProperty('original_tags') &&
      data[k]['original_tags'].length > 0
    ) {
      data[k].tags = data[k]['original_tags'].slice(0)
    }
  }
  return data
}

// Fix image url issue of swatch option
function getFilePath (fileName, ext, version) {
  var self = bcsffilter
  var ext = typeof ext !== 'undefined' ? ext : 'png'
  var version = typeof version !== 'undefined' ? version : '1'
  var prIndex = self.fileUrl.lastIndexOf('?')
  if (prIndex > 0) {
    var filePath = self.fileUrl.substring(0, prIndex)
  } else {
    var filePath = self.fileUrl
  }
  filePath += fileName + '.' + ext + '?v=' + version
  return filePath
}



BCSfFilter.prototype.prepareFilterParams = function(params, eventType) {
    // Get collection id
    if (!this.queryParams.hasOwnProperty('collection_scope')) {
        if (!this.isSearchPage()) {
            params.collection_scope = parseInt(this.collectionId);
            if (eventType == 'history') {
                var historyData = History.getState().data;
                if (historyData.hasOwnProperty('param') && historyData.param.hasOwnProperty('collection_scope')) {
                    params.collection_scope = this.collectionId = parseInt(historyData.param.collection_scope);
                } else {
                    params.collection_scope = this.collectionId = parseInt(bcSfFilterConfig.general.collection_id);
                }
            }
        } else {
            params.collection_scope = 0;
        }
    } else {
        params.collection_scope = Array.isArray(this.queryParams.collection_scope) ? this.queryParams['collection_scope'][0] : this.queryParams['collection_scope'];
    }
    // Get product/variant available or not
    if (this.getSettingValue('general.availableAfterFiltering') == true) {
        params.product_available = this.checkExistFilterOptionParam() === true ? true : this.productAvailable;
        params.variant_available = this.checkExistFilterOptionParam() === true ? true : this.variantAvailable;
    } else {
        params.product_available = this.productAvailable;
        params.variant_available = this.variantAvailable;
    }
    // Get Tag value
    if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) params.tag = this.collectionTags;
    // Display filter option items even they return no product
    if (this.getSettingValue('general.showOutOfStockOption')) params.zero_options = true;
    // Build Filter tree or not
    params.build_filter_tree = (typeof eventType !== 'undefined' && this.imutableFilterTree.indexOf(eventType) > -1) ? false : true; // Except events of elements in filter tree, all remaining events do not rebuild filter tree
    // Enable cache when request params doest not have filter option values, "page" param equal to 1 and "sort" param equal to default sorting
    // params.check_cache = (this.checkExistFilterOptionParam() === false && params['page'] == 1 && params['sort'] == this.defaultSorting && params['limit'] == this.getSettingValue('general.limit') && !this.isSearchPage() && !this.isVendorPage() && !this.isTypePage()) ? true : false;
    // Turn on price mode
    if (this.getSettingValue('general.priceMode') != '') params['price_mode'] = this.getSettingValue('general.priceMode');
    // Tag mode
    if (this.getSettingValue('general.tagMode') != '') params['tag_mode'] = this.getSettingValue('general.tagMode');
    // Availability Sorting
    if (this.getSettingValue('general.sortingAvailableFirst')) params.sort_first = 'available';
    // Vendor page: Get Vendor param
    if (this.isVendorPage() && params.hasOwnProperty('q')) {
        var vendorParam = this.getSettingValue('general.vendorParam');
        // params[vendorParam] = [params['q'].replace(/\+/g, ' ')];
        params[vendorParam] = [params['q']];
        delete params['q'];
    }
    // Type page: Get Type param
    // if (this.isTypePage() && params.hasOwnProperty('q')) {
    //     var typeParam = this.getSettingValue('general.typeParam');
    //     params[typeParam] = [params['q']];
    //     delete params['q'];
    // }
    params.country = Shopify.country;
    params.currency = Shopify.currency.active;
    params.return_all_currency_fields = false;
    params.currency_rate = Shopify.currency.rate;
    return params;
};

BCSfFilter.prototype.prepareSearchParams = function(params, eventType) {
    if (this.isSearchPage()) {
        params['q'] = this.getSearchTerm();
        if (this.searchTermKey != 'q') delete params[this.searchTermKey];
        var enableFuzzy = this.getSettingValue('search.enableFuzzy');
        if (enableFuzzy !== true ) params.fuzzy = enableFuzzy;
        if (this.getSettingValue('search.reduceMinMatch') !== false) {
            params.reduce_min_match = this.getSettingValue('search.reduceMinMatch');
        }
        if (this.getSettingValue('search.fullMinMatch')) params.full_min_match = true;
        if (this.getSettingValue('general.sortingAvailableFirst')) params.sort_first = 'available';
        if (this.getSettingValue('search.enablePlusCharacterSearch')) params.enable_plus_character_search = true;

        params.country = Shopify.country;
        params.currency = Shopify.currency.active;
        params.return_all_currency_fields = false;
        params.currency_rate = Shopify.currency.rate;
    }
    return params;
}; 

// suggestion
BCSfFilter.prototype.prepareSuggestionParams = function(searchTerm, eventType) {
    var params = {};
    params.shop = this.shopDomain;
    params.t = new Date().getTime();
    if (!this.getSettingValue('search.enableDefaultResult')) params.enable_default_result = false;
    var enableFuzzy = this.getSettingValue('search.enableFuzzy');
    if (enableFuzzy !== true ) params.fuzzy = enableFuzzy;
    if (this.getSettingValue('search.fullMinMatch')) params.full_min_match = true;
    if (this.getSettingValue('search.reduceMinMatch') !== false) {
      params.reduce_min_match = this.getSettingValue('search.reduceMinMatch');
    }
    if (this.getSettingValue('search.enablePlusCharacterSearch')) params.enable_plus_character_search = true;
    // Get product/variant available or not
    if (this.getSettingValue('search.productAvailable') == true) params.product_available = true;
    // Limit
    var blocks = this.getSettingValue('search.suggestionBlocks');
    var k;
    var blocksLength = blocks.length;
    for (k = 0; k < blocksLength; k++) {
        var id = blocks[k]['type'].slice(0, -1);
        params[id + '_limit'] = blocks[k]['number'];
    }
    params['dym_limit'] = this.getSettingValue('search.suggestionDymLimit');
    // Skip fields
    var skipFields = this.getSettingValue('search.skipFields');
    if (skipFields.length > 0) param.skipFields = skipFields;
    params.callback = 'BCSfSuggestionCallback';
    params.event_type = eventType;
    // Suggest types
    var suggestionTypes = eventType == 'suggest_dym' ? ['products'] : this.getSettingValue('search.suggestionTypes');
    params.suggest_types = suggestionTypes;
    // params = this.setThirdPartyAppParams(params);

    params.country = Shopify.country;
    params.currency = Shopify.currency.active;
    params.return_all_currency_fields = false;
    params.currency_rate = Shopify.currency.rate;

    return params;
};